import http from '../http'
const API_URL = "items"

class ItemsAPI {

  async createItems(Items) {
    const response = await http(`${API_URL}/save`, 'POST', Items)
    return response
  }

  async getAllItems(page) {
    const response = await http(`${API_URL}?page=${page}`, 'GET')
    return response
  } 

  async get(companyID ,page, search) {
    const response = await http(`${API_URL}?page=${page}`, 'POST', {
      search: search,
      companies_id: companyID,
    })
    return response
  }
 
  async getItems(ID) {
    const response = await http(`${API_URL}/show/${ID}`)
    return response
  }

  async updateItems(idItems, items) {
    const response = await http(`${API_URL}/update/${idItems}`, 'PUT', items)
    return response
  }

  async deleteItems(idItems) {
    const response = await http(`${API_URL}/delete/${idItems}`, 'DELETE')
    return response
  }  
  
}

export default new ItemsAPI()